import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../features/auth/useAuth";
import { useApi } from "../../services/useApi";

const TopBar = () => {
  const navigate = useNavigate();
  const api = useApi();
  const { user, clearAuth } = useAuth();

  const handleSignOut = () => {
    api.setToken(null);
    clearAuth();
    navigate("/login");
  };

  return (
    <header
      className="topbar"
      style={{
        position: "relative",
        height: 160,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 16px",
      }}
    >
      {/* Left: History Nav */}
      <nav className="topbar-nav">
        <NavLink to="/individual">Individual History</NavLink>
        <NavLink to="/teams">Team History</NavLink>
      </nav>

      {/* Center: Logo (absolutely centered) */}
      <img
        className="topbar-logo"
        src="/icons/Logo_PNG.png"
        alt="Logo"
        style={{
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          height: 40,
          width: "auto",
          objectFit: "contain",
          pointerEvents: "none",
        }}
      />

      {/* Right: User */}
      <div className="topbar-user">
        <img
          className="topbar-avatar"
          src={user?.profilePictureUrl || "/icons/Logo_PNG.png"}
          alt={user?.username || "User"}
        />
        <div className="topbar-user-meta">
          <div className="topbar-user-name">
            {user?.username || "CatchClicker User"}
          </div>
          <div className="topbar-user-email">{user?.email || ""}</div>
          <button
            type="button"
            className="topbar-signout"
            onClick={handleSignOut}
          >
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
};

export default TopBar;
